"use strict";

exports.__esModule = true;
exports.getBoundingClientRect = exports.getScrollOffset = void 0;

var _universalEnv = require("universal-env");

var _miniapp = _interopRequireDefault(require("./miniapp"));

var _web = _interopRequireDefault(require("./web"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line import/no-extraneous-dependencies
var element;

if ((_universalEnv.isMiniApp || _universalEnv.isWeChatMiniProgram) && !_universalEnv.isWeb) {
  // For cased that import wechat or miniapp sdk in web
  element = _miniapp.default;
} else {
  // Web as default
  element = _web.default;
}

var getScrollOffset = element.getScrollOffset;
exports.getScrollOffset = getScrollOffset;
var getBoundingClientRect = element.getBoundingClientRect;
exports.getBoundingClientRect = getBoundingClientRect;